const CACHE_KEY = "smws-stock-snapshot-v2";
const STAGING_HOST = "smws-stock-worker-staging.nm8pbj76vw.workers.dev";

export function availabilityPresentation(item = {}) {
  const presentations = {
    in_stock: ["In stock", "is-in-stock", true],
    limited_stock: ["Limited stock", "is-limited-stock", true],
    out_of_stock: ["Sold out", "is-out-of-stock", false],
    not_found: ["Not found online", "is-not-found", false],
    bad_url: ["Not found online", "is-not-found", false],
    no_public_page: ["Not found online", "is-not-found", false],
    checking: ["Checking…", "is-checking", false],
    queued: ["Queued", "is-queued", false],
  };
  const [label, className, available] = presentations[item.status]
    ?? ["Unknown", "is-unknown", false];
  return { label, className, available };
}

export function stockApiBase({ document, location }) {
  const hostname = String(location?.hostname ?? "").toLocaleLowerCase();
  if (hostname === "smws-staging.pages.dev" || hostname.endsWith(".smws-staging.pages.dev")) {
    return `https://${STAGING_HOST}`;
  }
  return String(document?.body?.dataset?.stockApi ?? "").replace(/\/+$/, "");
}

function itemsFromSnapshot(snapshot) {
  const entries = Array.isArray(snapshot?.items)
    ? snapshot.items.map((item) => [item.code ?? item.bottleId, item])
    : Object.entries(snapshot?.items ?? {});
  return new Map(entries.filter(([code]) => code));
}

export async function loadAvailability({
  document = globalThis.document,
  location = globalThis.location,
  fetchImpl = globalThis.fetch,
  storage = globalThis.localStorage,
} = {}) {
  const base = stockApiBase({ document, location });
  if (!base) return new Map();
  try {
    const response = await fetchImpl(`${base}/snapshot`, {
      method: "GET",
      headers: { Accept: "application/json" },
      cache: "no-store",
    });
    if (!response.ok) throw new Error(`Stock snapshot returned ${response.status}`);
    const snapshot = await response.json();
    try { storage?.setItem(CACHE_KEY, JSON.stringify(snapshot)); } catch {}
    return itemsFromSnapshot(snapshot);
  } catch (error) {
    try {
      const cached = storage?.getItem(CACHE_KEY);
      if (cached) return itemsFromSnapshot(JSON.parse(cached));
    } catch {}
    throw error;
  }
}

export async function submitCatalogueManifest({
  document = globalThis.document,
  location = globalThis.location,
  records,
  fetchImpl = globalThis.fetch,
} = {}) {
  const base = stockApiBase({ document, location });
  if (!base || !records?.length) return null;
  const latestOutturn = records.map(({ outturn }) => outturn).filter(Boolean).sort().at(-1) ?? "";
  const bottles = records.filter(({ smwsUrl }) => smwsUrl).map((record) => ({
    code: record.code,
    name: record.name,
    url: record.smwsUrl,
    outturn: record.outturn,
    currentOutturn: Boolean(latestOutturn && record.outturn === latestOutturn),
  }));
  try {
    const response = await fetchImpl(`${base}/manifest`, {
      method: "POST",
      headers: { Accept: "application/json", "Content-Type": "application/json" },
      body: JSON.stringify({
        source: "smws-index",
        generatedAt: new Date().toISOString(),
        latestOutturn,
        scanLimit: 40,
        bottles,
      }),
    });
    return response.ok ? response.json() : null;
  } catch {
    return null;
  }
}
